import * as o from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/Coins.es.js";
const e = o.forwardRef((r, s) => /* @__PURE__ */ o.createElement(t, { ref: s, ...r, weights: n }));
e.displayName = "CoinsIcon";
const m = e;
export {
  m as Coins,
  e as CoinsIcon
};
